import Icon from "common/components/elements/icons";
import TruncateText from "common/components/elements/truncate-text";
import PropTypes from "prop-types";

const MembershipLabel = ({
   name,
}) => {

   return (
      <div
         className='w-fit max-w-full flex items-center gap-2 px-3 py-[6px] rounded-full bg-panel border border-divider'
      >
         <Icon
            name='membership'
            size='xl'
            color='action'
         />
         <TruncateText
            text={ name }
            textClass='text-sm leading-[18px] text-major'
            textSize='14px'
         />
      </div>
   )
}

MembershipLabel.propTypes = {
   name: PropTypes.string,
}

export default MembershipLabel;
